export enum ConvertType {
    Json = 0,
    Csv = 1,
}
